/**
 * @generated SignedSource<<28912c40a450acf953b8ea25816a29f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedStarRating_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSellerRating_seller">;
  readonly " $fragmentType": "SharedStarRating_seller";
};
export type SharedStarRating_seller$key = {
  readonly " $data"?: SharedStarRating_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedStarRating_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedStarRating_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSellerRating_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "b9b4143ca577e67da7a4433604ea778f";

export default node;
